module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Laptop.7664f940.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Laptop.svg
// module id = 1607
// module chunks = 0